/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 16:44:35
 * @LastEditTime: 2022-06-10 13:37:29
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/MiniProgramRegistrationEntity/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
const MiniProgramRegistrationEntity = ({ value, onChange, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramRegistrationEntity',
      )}>
      <Checkbox checked={value} onChange={onChange} disabled={disabled}>
        {getI18n(
          'salesChannelMiniProgramSettings.index.miniProgramRegistrationEntityTips',
        )}
      </Checkbox>
    </SectionWrapper>
  );
};

export default MiniProgramRegistrationEntity;
